export const SPLITIO_TIMEOUT_MS = 5_000;
export const SPLIT_OVERRIDES_KEY = 'menti_split_overrides';
export const DEFAULT_LOCALE = 'en-US';
export const LOCALES = ['en-US', 'pt-BR', 'es-ES', 'de-DE'];
export const USER_LOCALE_STORAGE_KEY = 'mm-user-locale';
